<template v-if="isShowProductButton">
  <div :class="['p-button', buttonClass]">
    <template v-if="isUseButtonCustom">
      <a :href="product.link">
        <div
          v-html="buttonHtml"
          class="p-button-custom"
          :style="[buttonStyles, isHoverButon ? buttonHoverStyles : {}]"
          @mouseover="mouseOverProduct"
          @mouseout="mouseOutProduct"
        ></div>
      </a>
    </template>
    <template v-else>
      <div v-html="product.add_to_cart_html.replace('%s', buttonHtml)"></div>
    </template>
  </div>
</template>

<script>
export default {
  name: "ProductButton",
  props: ["product"],
  data: function() {
    return {
      isHover: false
    };
  },
  computed: {
    isShowProductButton: function() {
      return this.$store.state.front.settings.buttonDisplay;
    },
    isUseButtonCustom: function() {
      return this.$store.state.front.settings.buttonCustom;
    },
    isHoverButon: function() {
      return this.isHover;
    },
    buttonStyles: function() {
      return {
        color: this.$store.state.front.settings.buttonColor,
        fontSize: this.$store.state.front.settings.buttonFontsize,
        backgroundColor: this.$store.state.front.settings.buttonBackground,
        borderSize: this.$store.state.front.settings.buttonBorderSize,
        borderColor: this.$store.state.front.settings.buttonBorderColor,
        borderRadius: this.$store.state.front.settings.buttonBorderRound
      };
    },
    buttonHoverStyles: function() {
      return {
        color: this.$store.state.front.settings.buttonColorHover,
        backgroundColor: this.$store.state.front.settings.buttonBackgroundHover,
        borderColor: this.$store.state.front.settings.buttonBorderColorHover
      };
    },
    buttonClass: function() {
      return this.$store.state.front.settings.buttonClass;
    },
    buttonHtml: function() {
      let html =
        '<span class="p-button-icon">' +
        '<i class="' +
        this.$store.state.front.settings.buttonIcon +
        '"></i>' +
        "</span>" +
        '<span class="p-button-text">' +
        this.$store.state.front.settings.buttonText +
        "</span>";
      return html;
    },
    buttonText: function() {
      return this.$store.state.front.settings.buttonText;
    },
    buttonIcon: function() {
      return this.$store.state.front.settings.buttonText;
    }
  },
  methods: {
    mouseOverProduct: function(event) {
      this.isHover = true;
    },
    mouseOutProduct: function(event) {
      this.isHover = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.p-button-custom {
  background: green;
  color: #fff;
  text-transform: uppercase;
  border-radius: 3px;
  padding: 8px 15px;
  text-align: center;
  margin: 5px auto auto;
}
.p-button {
  a {
    background: green;
    color: #fff;
    border-radius: 3px;
    padding: 8px 15px;
    text-align: center;
    margin: 5px auto auto;
  }
}
</style>